var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmit()
      }
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "description": "Please enter your email",
      "label": "Reset Password",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Enter your email",
      "name": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('email')) + "\n                  ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-left": "2rem"
    }
  }, [_c('vue-button-spinner', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#20a8d8",
      "color": "white",
      "border-radius": "6px",
      "width": "150px"
    },
    attrs: {
      "is-loading": _vm.isLoading,
      "disabled": _vm.isLoading,
      "type": "submit"
    }
  }, [_c('span', [_vm._v("Kirim")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-danger",
    attrs: {
      "to": '/login'
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Cancel")])], 1)], 1)])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\icon.jpeg",
      "width": "100%"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e45e51","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ResetPassword.vue
// module id = 173
// module chunks = 0